const trimSlash = url => String(url ?? '').replace(/\/$/, '');

export async function emitQuimedikDocument(payloadBody) {
  const baseUrl = trimSlash(process.env.REACT_APP_QUIMEDIK_API_URL);
  const token = process.env.REACT_APP_QUIMEDIK_BEARER_TOKEN;

  if (!baseUrl || !token) {
    console.warn('[emitQuimedikDocument] Variables REACT_APP_QUIMEDIK_* no configuradas; se omite emisión SUNAT.');
    return null;
  }

  try {
    const response = await fetch(`${baseUrl}/api/documents`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payloadBody),
    });

    if (!response.ok) {
      const text = await response.text();
      console.error('[emitQuimedikDocument] Error HTTP', response.status, text);
      return null;
    }

    return await response.json();
  } catch (err) {
    console.error('[emitQuimedikDocument]', err);
    return null;
  }
}
